<template>
  <div style="background-color: #fff">
    <div class="fincal-content">
      <p class="fincal-head" style="margin-top: 7%">
        <a class="fincalrouter" href="">Home</a> » Privacy Policy
      </p>
      <h1 class="oplicy-h1">
        <img
          src="../assets/2023/12/privacy-policy-300x300.gif"
          style="width: 80px"
          alt=""
        />Privacy Policy
      </h1>
      <div class="fincal-wenzi fincal-head">
        Our Privacy Policy is designed to assist you in understanding how we
        collect and use the personal information you provide to us and to assist
        you in making informed decisions when using our site and our products
        and services.
      </div>

      <h2>What Information Do We Collect?</h2>
      <div class="fincal-wenzi fincal-head">
        When you visit our website, you may provide us with two types of
        information: personal information you knowingly choose to disclose that
        is collected on an individual basis and Website use information
        collected on an aggregate basis as you and others browse our website.
      </div>
      <h3>1. Personal Information You Choose to Provide</h3>
      <ul>
        <li class="fincal-wenzi">
          <strong>Registration Information.</strong>You will provide us
          information about yourself, your firm or company, and your practices
          when you register to be a member of ‘Company Search Incorporated’,
          register for certain services, or register for email newsletters and
          alerts. You may also provide additional comments on how you see
          ‘Company Search Incorporated’ servicing your needs and interests.
        </li>

        <li class="fincal-wenzi">
          <strong>Email Information. </strong>If you choose to correspond with
          us through email, we may retain the content of your email messages
          together with your email address and our responses.
        </li>
      </ul>

      <h3>2. Website Use Information</h3>
      <div class="fincal-wenzi fincal-head">
        Similar to other commercial websites, our website utilizes a standard
        technology called “cookies” (see explanation below, “What Are Cookies?”)
        and Web server logs to collect information about how our website is
        used. Information gathered through cookies and Web server logs may
        include the date and time of visits, the pages viewed, time spent at our
        website, and the Websites visited just before and just after our
        website. We, our advertisers and ad serving companies may also use small
        technology or pieces of code to determine which advertisements and
        promotions users have seen and how users responded to them.
      </div>
      <h2>How Do We Use the Information That You Provide to Us?</h2>
      <div class="fincal-wenzi fincal-head">
        Broadly speaking, we use personal information for purposes of
        administering and expanding our business activities, providing customer
        service and making available other products and services to our
        customers and prospective customers. Occasionally, we may also use the
        information we collect to notify you about important changes to our
        website, new services and special offers we think you will find
        valuable. You may notify us at any time if you do not wish to receive
        these updates and/or offers by emailing us at  <a class="aclass" href="mailto:request@CSIbizInfo.com">request@CSIbizInfo.com</a>
      </div>

      <h2>What Are Cookies?</h2>
      <div class="fincal-wenzi fincal-head">
        A cookie is a very small text document, which often includes an
        anonymous unique identifier. When you visit a website, that site’s
        computer asks your computer for permission to store this file in a part
        of your hard drive specifically designated for cookies. Each Website can
        send its own cookie to your browser if your browser’s preferences allow
        it, but (to protect your privacy) your browser only permits a Website to
        access the cookies it has already sent to you, not the cookies sent to
        you by other sites. Some of our business partners (e.g., advertisers)
        use cookies that originate from their sites. We have no access or
        control over those cookies.
      </div>
      <h2>How Do We Use Information We Collect from Cookies?</h2>
      <div class="fincal-wenzi fincal-head">
        As you use our website, the site uses its cookies to differentiate you
        from other users. In some cases, we also use cookies to prevent you from
        seeing unnecessary advertisements or requiring you to log in more than
        once for security reasons. Cookies, in conjunction with our Web server’s
        log files, allow us to calculate the aggregate number of people visiting
        our website and which parts of the site are most popular. This helps us
        gather feedback in order to constantly improve our website and better
        serve our customers. Cookies do not allow us to gather any personal
        information about you and we do not generally store any personal
        information that you provided to us in your cookies.
      </div>
      <ul>
        <li class="fincal-wenzi"><h3>Sharing Information with Third Parties</h3></li>
        <div class="fincal-wenzi">
          We may enter into alliances, partnerships or other business
          arrangements with third parties who may be given access to personal
          information including your name, address, telephone number and email
          for the purpose of providing you information regarding products and
          services that we think will be of interest to you. In connection with
          alliances, partnerships or arrangements, we may also provide certain
          information to third parties if we have determined that the
          information will be used in a responsible manner by a responsible
          third party. For example, some of our partners operate stores or
          provide services on our site, while others power offerings developed
          by us for your use. We also use third parties to facilitate our
          business, including, but not limited to, sending email and processing
          credit card payments. In connection with these offerings and business
          operations, our partners and other third parties may have access to
          your personal information for use in connection with the business
          activities. As we develop our business, we may buy or sell assets or
          business offerings. Customer, email, and visitor information is
          generally one of the transferred business assets in these types of
          transactions. We may also transfer such information in the course of
          corporate divestitures, mergers, or any dissolution.
        </div>

        <li class="fincal-wenzi"><h3>Notice of New Services and Changes</h3></li>
        <div class="fincal-wenzi">
          Occasionally, we may also use the information we collect to notify you
          about important changes to our website, new services and special
          offers we think you will find valuable. As our customer, you will be
          given the opportunity to notify us if you would not like to receive
          these offers, by sending us an email request at<a class="aclass" href="mailto:request@CSIbizInfo.com">request@CSIbizInfo.com</a>
        </div>
      </ul>
       <h2>How Do We Secure Information Transmissions?</h2>
      <div class="fincal-wenzi fincal-head">
      Email is not recognized as a secure medium of communication. For this reason, we request that you do not send private information to us by email. Some of the information you may enter on our website may be transmitted securely via Secure Sockets Layer SSL, 128-bit encryption services. Pages utilizing this technology will have URLs that start with HTTPS instead of HTTP. Please contact <a class="aclass" href="mailto:request@CSIbizInfo.com">request@CSIbizInfo.com</a> if you have any questions or concerns.


      </div>
         <h2>How Can You Access and Correct Your Information?</h2>
      <div class="fincal-wenzi fincal-head">
     You may request access to all your personally identifiable information that we collect online and maintain in our database by emailing <a class="aclass" href="mailto:request@CSIbizInfo.com">request@CSIbizInfo.com</a>
      </div>
      <ul>
        <li><h3>Certain Disclosures</h3></li>
        <div class="fincal-wenzi fincal-head">
  We may disclose your personal information if required to do so by law or subpoena or if we believe that such action is necessary to (a) conform to the law or comply with legal process served on us or affiliated parties; (b) protect and defend our rights and property, our site, the users of our site, and/or our affiliated parties; (c) act under circumstances to protect the safety of users of our site, us, or third parties.
      </div>
      </ul>
      <h2>What About Other Websites Linked to Our Website?</h2>
      <div class="fincal-wenzi ">
   We are not responsible for the practices employed by Websites linked to or from our website nor the information or content contained therein. Often links to other Websites are provided solely as pointers to information on topics that may be useful to the users of our website.
      </div>
      <div class="fincal-wenzi fincal-head">
        Please remember that when you use a link to go from our Website to another Website, our Privacy Policy is no longer in effect. Your browsing and interaction on any other Website, including Websites which have a link on our Website, is subject to that Website’s own rules and policies. Please read those rules and policies before proceeding.
      </div>
         <ul>
        <li><h3>Your Consents</h3></li>
        <div class="fincal-wenzi fincal-head">
            By using our website, you consent to our collection and use of your personal information as described in this Privacy Policy. If we change our privacy policies and procedures, we will post those changes on our website to keep you aware of what information we collect, how we use it and under what circumstances we may disclose it.
      </div>
      </ul>
    </div>
    
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
      '$route.hash': function() {
        // 在这里可以处理hash变化后的逻辑
      // this.scrollToAnchor()
      }
  },
  methods: {
    //  scrollToAnc
    gotoarticle(route) {
      this.$router.push({ name: route });
      // window.location.hash = "#about#top";
    },
    //   const el = document.querySelector(this.$route.hash);
    //   el.scrollIntoView({ behavior: "smooth" });
    // },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.scrollToAnchor()
  },
};
</script>

<style scoped>
ol,
ul {
  margin-left: 30px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.nectar-video-inner {
  width: 100%;
  position: relative;
  height: 610px;
}
.row-bg-layer {
  position: absolute;
  width: 100%;
  height: 610px;
  z-index: 9;
}
.row-bg-layertwo {
  position: absolute;
  width: 100%;
  height: 390px;
  z-index: 9;
}
.video-content {
  /* z-index: 10; */
  width: 100%;
  display: flex;
  justify-content: center;
  /* position: relative; */
}
.postion {
  position: absolute;
  top: 26%;
  right: 19%;
  width: 25%;
  z-index: 11;
}
.video-content-title {
  font-size: 81px;
  color: #fff;
  margin-bottom: 0px;
  width: 83%;
  margin: auto;
  text-align: center;
}
.video-content-left {
  position: absolute;
  z-index: 11;
  top: 36%;
  text-align: center;
}
.start_font {
  font-family: "AlegreyaSans-Medium";
  font-size: 61px;
  width: auto;
  color: #1290c9;
  text-align: left;
  font-style: normal;
  position: relative;
  display: inline-block;
  z-index: 10;
}
.focus {
  position: relative;
}
h2 {
  font-family: Alegreya Sans;
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  margin: 7px 0px;
}

head {
}
h3 {
  font-family: Alegreya Sans;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  /* color: #3d7cbf; */
  text-align: left;
  margin-bottom: 8px;
  margin-top: 10px;
}
.nectar-video-bg {
  height: 100%;
  position: relative;
  top: -25%;
}
.Financial-text {
  padding: 0 20px;
  border-left: 1px solid #ccc;
  color: #fff;
}
.fincalrouter {
  color: #1290c9;
}
.fincal-content {
  margin: auto;
  width: 88%;
  padding: 80px 0px;
  font-size: 18px;
}
.fincal-head {
  padding-bottom: 27px;
}
.fincal-wenzi {
  font-family: Roboto;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
.wenzhang {
  color: #fff;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  width: 200px;
  margin: auto;
  margin-top: -50px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.wenzhangtwo {
  color: #fff;
  padding: 6px;
  font-size: 18px;
  margin: auto;
}
.nectar-video-innertwo {
  height: 390px;
  background-image: url("../assets/2024/01/artificial-intelligence-leadership.webp");
  background-position-y: 631px;
  transition: transform 0.42s ease;
  background-size: 100%;
}
.nextewnzheng {
  overflow: hidden;
}
.nextewnzheng {
  transition: transform 0.42s ease;
}

.nextewnzheng:hover .nectar-video-innertwo {
  cursor: pointer;
  transform: scale(1.1);
  transition: transform 0.42s ease;
}
.nextewnzheng :hover .row-bg-layertwo {
  opacity: 0.1 !important;
}
@media screen and (max-width: 500px) {
  .video-content-title {
    font-size: 51px;
  }
}
.oplicy-h1 {
  display: flex;
  align-items: center;
  font-size: 82px;
  margin-bottom: 40px;
      font-family:" Alegreya Sans";
}
h3{
  font-size: 24px;
}
.oplicy-h1 img{
  width: 55px !important;
}
.aclass{
  cursor: pointer;
  color: #1290c9;
}
</style>